module.exports = __webpack_public_path__ + "img/img151_15.61c626f8.png";